module.exports = __webpack_public_path__ + "static/img/21.f2cbcae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/moho/21.png
// module id = MS5+
// module chunks = 0